import { makeStyles } from '@material-ui/core';

export default makeStyles((theme) => ({
  container: {
    [theme.breakpoints.up('sm')]: {
      minWidth: 420,
    },
  },
}));
